"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scroll_listeners_1 = require("./scroll-listeners");
Object.defineProperty(exports, "scrollListeners", { enumerable: true, get: function () { return scroll_listeners_1.scrollListeners; } });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/ScrollListeners/index.js
// module id = 477
// module chunks = 8